(function() {
    'use strict';

    angular
        .module('udt', [])
        .factory('GUIUtils', GUIUtils);

    function GUIUtils () {

        var statusTypes = ['default', 'danger', 'primary', 'success', 'info', 'warning'];

        var service = {
            getActionsTemplate: getActionsTemplate,
            getStatusTemplate: getStatusTemplate,
            expandWeekCodeString: expandWeekCodeString,
            mailto: mailto,
            objectToArray: objectToArray,
            objectToArrayByKey: objectToArrayByKey,
            objectsToArrayByKey: objectsToArrayByKey,
            getDays: getDays,
            daysToWeekCodeString: daysToWeekCodeString,
            weekCodeStringToDays: weekCodeStringToDays,
            getMonths: getMonths,
            monthsCodeStringToMonths: monthsCodeStringToMonths,
            monthsToMonthCodeString: monthsToMonthCodeString,
            icd10CodeToListNames: icd10CodeToListNames,
            getGender: getGender,
            getMaritalStatus: getMaritalStatus,
            getRace: getRace,
            getEthnicity: getEthnicity,
            resetUserPicture: resetUserPicture,
            getDefaultUserPicture: getDefaultUserPicture,
            getDefaultUserPictureContentType: getDefaultUserPictureContentType,
            colorHtmlYesNo: colorHtmlYesNo,
            colorHtmlStatus: colorHtmlStatus,
            getOnset: getOnset,
            weekStringJavaToJS: weekStringJavaToJS,
            groupSessionStatusColor: groupSessionStatusColor,
            getAvailavility: getAvailavility,
            getColorHtmlAvailability : colorHtmlAvailability,
            shiftStatus : shiftStatus,
            getDaysAsObject: getDaysAsObject,
            getOrderStatus: getOrderStatus,
            colorHtmlStatusRequisition: colorHtmlStatusRequisition,
            getItemStatus: getItemStatus,
            getEvaluationStatus: getEvaluationStatus,
            getAdmissionMedicationAction: getAdmissionMedicationAction
        };

        return service;

        /**
         * Return a Action Template for grid bootstrap based
         * @param data
         * @param entity
         * @param buttons
         * @returns {string}
         */
        function getActionsTemplate (data, entity, buttons) {
            var stButtons = '';
            for (var i = 0, len = buttons.length; i < len; i++) {
                switch(buttons[i]) {
                  case 'view': {
                      stButtons += '<a class="dt-btn primary" title="See Details" ui-sref="' + entity + '-detail({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '">' +
                          '<i class="fa fa-eye" aria-hidden="true"></i></a>';
                      break;
                  }
                    case 'update': {
                        stButtons += '<a class="dt-btn warning" title="Edit" ui-sref="' + entity + '.edit({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '/edit">' +
                            '<i class="fa fa-edit" aria-hidden="true"></i></a>';
                        break;
                    }
                    case 'delete': {
                        stButtons += '<a class="dt-btn danger" title="Delete" ui-sref="' + entity + '.delete({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/delete">' +
                            '<i class="fa fa-trash" aria-hidden="true"></i></a>';
                        break;
                    }
                    case 'download': {
                        if (data.status) {
                            stButtons += '<a class="dt-btn primary" title="Download" ui-sref="' + entity + '.download({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/download">' +
                                '<i class="fa fa-download" aria-hidden="true" style="color: green"></i></a>';
                        } else {
                            stButtons += '<a class="dt-btn primary" title="Download">' +
                                '<i class="fa fa-download" aria-hidden="true" style="opacity: 0.6; color: red"></i></a>';
                        }
                        break;
                    }
                    case 'all' : {
                        stButtons += '<a class="dt-btn primary" ui-sref="' + entity + '-detail({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '">' +
                            '<i class="fa fa-eye" aria-hidden="true"></i></a>';
                        stButtons += '<a class="dt-btn warning" ui-sref="' + entity + '.edit({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '/edit">' +
                            '<i class="fa fa-edit" aria-hidden="true"></i></a>';
                        stButtons += '<a class="dt-btn danger" title="Delete" ui-sref="' + entity + '.delete({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/delete">' +
                            '<i class="fa fa-trash" aria-hidden="true"></i></a>';
                        break;
                    }
                }
            }

            return stButtons;
        }

        /**
         * Return a Status Template for grid bootstrap based
         * @param label
         * @param type
         * @returns {string}
         */
        function getStatusTemplate(label, type) {

            var index = statusTypes.indexOf(type);
            if (index != -1) {
                return '<small class="label label-' + statusTypes[index] + '">' + label + '</small>';
            } else {
                return '<small class="label label-' + statusTypes[0] + '">' + label + '</small>';
            }
        }

        /**
         * Expand a week code String '0000000' to human days week
         * @param weekCode binary String length 7 Ex 0100101 ==> MON,THU,SAT
         * @param separator
         */
        function expandWeekCodeString(weekCode, separator) {
            var days = '';
            for (var i = 0; i < weekCode.length; i++) {
                if (weekCode[i] != '0') {
                    if ((days.length > 0) && (i > 0)) {
                        days += separator;
                    }
                    switch (i) {
                        case 0:
                            days += 'MON';
                            break;
                        case 1:
                            days += 'TUE';
                            break;
                        case 2:
                            days += 'WED';
                            break;
                        case 3:
                            days += 'THU';
                            break;
                        case 4:
                            days += 'FRI';
                            break;
                        case 5:
                            days += 'SAT';
                            break;
                        case 6:
                            days += 'SUN';
                            break;
                    }
                } else{
                    if ((i == weekCode.length -1) && days == '') {
                        days += '-';
                    }
                }
            }

            return days;
        }

        function getDays() {
            return ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
        }

        function weekCodeStringToDays(weekCode) {
            if (!weekCode) {
                weekCode = '0000000';
            }

            var days = [];
            for (var i = 0; i < weekCode.length; i++) {
                if (weekCode.charAt(i) == '1') {
                    switch (i) {
                        case 0:
                            days.push('MON');
                            break;
                        case 1:
                            days.push('TUE');
                            break;
                        case 2:
                            days.push('WED');
                            break;
                        case 3:
                            days.push('THU');
                            break;
                        case 4:
                            days.push('FRI');
                            break;
                        case 5:
                            days.push('SAT');
                            break;
                        case 6:
                            days.push('SUN');
                            break;
                    }
                }
            }

            return days;
        }

        function daysToWeekCodeString(days) {
            var code = '0000000';

            if (days) {
                code = code.split("");

                for (var i = 0; i < days.length; i++) {
                    switch (days[i]) {

                        case 'MON':
                            code[0] = '1';
                            break;
                        case 'TUE':
                            code[1] = '1';
                            break;
                        case 'WED':
                            code[2] = '1';
                            break;
                        case 'THU':
                            code[3] = '1';
                            break;
                        case 'FRI':
                            code[4] = '1';
                            break;
                        case 'SAT':
                            code[5] = '1';
                            break;
                        case 'SUN':
                            code[6] = '1';
                            break;
                    }
                }

                return code.join("");
            }

            return code;
        }

        function getMonths() {
            return ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        }

        function monthsCodeStringToMonths(monthCode) {
            var days = [];
            for (var i = 0; i < monthCode.length; i++) {
                if (monthCode.charAt(i) == '1') {
                    switch (i) {
                        case 0:
                            days.push('JAN');
                            break;
                        case 1:
                            days.push('FEB');
                            break;
                        case 2:
                            days.push('MAR');
                            break;
                        case 3:
                            days.push('APR');
                            break;
                        case 4:
                            days.push('MAY');
                            break;
                        case 5:
                            days.push('JUN');
                            break;
                        case 6:
                            days.push('JUL');
                            break;
                        case 7:
                            days.push('AUG');
                            break;
                        case 8:
                            days.push('SEP');
                            break;
                        case 9:
                            days.push('OCT');
                            break;
                        case 10:
                            days.push('NOV');
                            break;
                        case 11:
                            days.push('DEC');
                            break;
                    }
                }
            }

            return days;
        }

        function monthsToMonthCodeString(months) {
            var code = '000000000000';

            if (months) {
                code = code.split("");

                for (var i = 0; i < months.length; i++) {
                    switch (months[i]) {
                        case 'JAN':
                            code[0] = '1';
                            break;
                        case 'FEB':
                            code[1] = '1';
                            break;
                        case 'MAR':
                            code[2] = '1';
                            break;
                        case 'APR':
                            code[3] = '1';
                            break;
                        case 'MAY':
                            code[4] = '1';
                            break;
                        case 'JUN':
                            code[5] = '1';
                            break;
                        case 'JUL':
                            code[6] = '1';
                            break;
                        case 'AUG':
                            code[7] = '1';
                            break;
                        case 'SEP':
                            code[8] = '1';
                            break;
                        case 'OCT':
                            code[9] = '1';
                            break;
                        case 'NOV':
                            code[10] = '1';
                            break;
                        case 'DEC':
                            code[11] = '1';
                            break;
                    }
                }

                return code.join("");
            }

            return code;
        }

        /**
         * Returns a URL for a mailto-link
         * @param  {String} recepient    - Recepient email address
         * @param  {Object} opts         - Options to construct the URL
         * @param  {String} opts.cc      - Cc recepient email address (optional)
         * @param  {String} opts.bcc     - Bcc recepient email address (optional)
         * @param  {String} opts.subject - Email subject (optional)
         * @param  {String} opts.body    - Email body (optional). Separate lines with the newline character (\n)
         * @return {String}              - Returns the URL to put into the href-attribute of a mailto link
         */
        function mailto(recepient, opts) {
            var link = '<a href="mailto:';
            link += recepient;//window.encodeURIComponent(recepient);
            var params = [];
            angular.forEach(opts, function (value, key) {
                params.push(key.toLowerCase() + "=" + window.encodeURIComponent(value));
            });
            if (params.length > 0) {
                link += "?" + params.join("&");
            }
            link += '">' + recepient + '</a>';
            return link;
        }

        /**
         * Return object fields as array
         * @param object
         */
        function objectToArray(object) {

            var toArray = [];
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    toArray.push(object[key]);
                }
            }
            return toArray;
        }

        /**
         * Return object fields as array
         * @param object
         */
        function objectToArrayByKey(object, key) {

            var toArray = [];
            if (object.hasOwnProperty(key)) {
                toArray.push(object[key]);
            }
            return toArray;
        }

        /**
         * Return object fields as array
         * @param object
         */
        function objectsToArrayByKey(objects, key) {

            var toArray = [];
            objects.forEach(function (elem) {
                toArray.push(objectToArrayByKey(elem, key));
            });

            return toArray;
        }

        function icd10CodeToListNames(data) {
            var codes = '';
            for(var i=0; i < data.length; i++){
                if(codes.length > 0 && i > 0){
                    codes += ', ';
                }
                codes += data[i].code;
            }
            // data[i].icd10SCodes = codes;
            return codes;
        }

        function getGender() {
            return ['MALE', 'FEMALE', 'ANDROGYNE', 'ANDROGYNOUS', 'AGENDER', 'BIGENDER', 'CIS', 'CISGENDER','CIS_FEMALE',
                'CIS_MALE', 'GENDER_NEUTRAL', 'GENDERQUEER', 'FEMALE_TO_MALE', 'MALE_TO_FEMALE','NON_BINARY', 'PANGENDER',
                'POLYGENDER', 'TWO_SPIRIT', 'THIRD_GENDER', 'TRANSGENDER', 'TRANSSEXUAL', 'OTHER', 'UNKNOWN'];
        }

        function getAdmissionMedicationAction() {
            return ['CONTINUE_ON_ADMISSION', 'DESTROY', 'STORE'];
        }

        function getOnset() {
            return ['Childhood', 'Adulthood', 'Unknown'];
        }

        function getMaritalStatus() {
            return ['Single', 'Divorced', 'Married'];
        }

        function getRace() {
            return ['White', 'Black', 'Mestizo'];
        }

        function getEthnicity() {
            return ['Anglo', 'Afro-American', 'Hispanic-Latin', 'Asian']
        }

        function getAvailavility() {
            return ['OCCUPIED', 'AVAILABLE'];
        }

        function getDefaultUserPicture() {
            return "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";
        }

        function getDefaultUserPictureContentType() {
            return "image/jpeg";
        }

        function resetUserPicture(data){
            data.picture = getDefaultUserPicture();
            data.pictureContentType = getDefaultUserPictureContentType();
        }

        function colorHtmlYesNo(value){
            if (value) {
                return getStatusTemplate('Yes', 'success');
            } else {
                return getStatusTemplate('No', 'danger');
            }
        }

        function colorHtmlAvailability(value){
            if (value == 'AVAILABLE') {
                return getStatusTemplate(value, 'success');
            } else {
                return getStatusTemplate(value, 'danger');
            }
        }

        function getEvaluationStatus() {
            return ['Pending', 'InReview', 'Revoked', 'Expired', 'Late', 'Finalized', 'Amended'];
        }

        function colorHtmlStatus(value) {
            if(value){
                switch(value) {
                    case 'Pending':
                        return getStatusTemplate(value, 'danger');
                    case 'InProcess':
                        return getStatusTemplate(value, 'warning');
                    case 'PendingReview':
                        return getStatusTemplate(value, 'warning');
                    case 'Finalized':
                        return getStatusTemplate(value, 'success');
                    case 'Completed':
                        return getStatusTemplate(value, 'success');
                    case 'Revoked':
                        return getStatusTemplate(value, 'danger');
                    default :
                        return getStatusTemplate(value, 'info');
                }
            }
        }

        function weekStringJavaToJS(week) {
            var jsWeek = '';

            // jsWeek[0] = week[7];
            jsWeek += week[6];
            for (var i = 0; i < week.length - 1; i++) {
                // jsWeek[i] = week[i - 1];
                jsWeek += week[i];
            }

            return jsWeek;
        }

        function groupSessionStatusColor(status) {
            if (status) {
                switch (status) {
                    case 'PENDING':
                        return '#00c0ef';
                    case 'STARTED' :
                        return '#0073b7';
                    case 'REVIEW' :
                        return '#f39c12';
                    case 'COMPLETE':
                        return '#00a65a';
                    case 'DISABLED':
                        return '#dd4b39';
                    default:
                        return '#00c0ef'
                }
            }
        }

        function shiftStatus(value) {
            if(value){
                switch(value) {
                    case 'Pending':
                        return getStatusTemplate(value, 'danger');
                    case 'Review':
                        return getStatusTemplate(value, 'warning');
                    case 'Finalized':
                        return getStatusTemplate(value, 'success');
                    default :
                        return getStatusTemplate(value, 'info');
                }
            }
        }

        function getOrderStatus() {
            return ['CANCELED', 'FINISHED', 'SCHEDULED', 'GENERATED'];
        }

        function getDaysAsObject() {
            return [{
                id: 1,
                name: 'MON'
            }, {
                id: 2,
                name: 'TUE'
            }, {
                id: 3,
                name: 'WED'
            }, {
                id: 4,
                name: 'THU'
            }, {
                id: 5,
                name: 'FRI'
            }, {
                id: 6,
                name: 'SAT'
            }, {
                id: 7,
                name: 'SUN'
            }];
        }

        function colorHtmlStatusRequisition(value) {
            if (value.toString()) {
                switch (value) {
                    case 'PRINTED':
                        return getStatusTemplate(value, 'success');
                    case 'SCHEDULED':
                        return getStatusTemplate(value, 'warning');
                    case 'MANIFESTED':
                        return getStatusTemplate(value, 'primary');
                }
            }
        }

        function getItemStatus() {
            return ['SCHEDULED', 'PRINTED', 'MANIFESTED'];
        }
    }
})();
